String.prototype.format = function() {
    var formatted = this;
    for(let arg in arguments) {
        formatted = formatted.replace("{" + arg + "}", arguments[arg]);
    }
    return formatted;
};

function wm_update_product_photo(e) {
    e.preventDefault();

    let data = e.target.dataset;
    let img_url = data.large_image;
    let img_width = data.large_image_width;
    let img_height = data.large_image_height;

    let thumb = e.target.closest('[data-thumb-srcset]');
    let img_srcset = thumb.getAttribute('data-thumb-srcset');

    let featured_img_link = document.querySelector('.product-single__photo a');
    let featured_img = featured_img_link.querySelector('img');

    featured_img_link.setAttribute('href', img_url);
    featured_img.setAttribute('width', img_width);
    featured_img.setAttribute('height', img_height);
    featured_img.setAttribute('srcset', img_srcset);

    let thumbs = document.querySelectorAll('.product-single__gallery [data-thumb]');
    for (let el of thumbs) {
        el.classList.remove('is-active');
    }

    thumb.classList.add('is-active');
}

function wm_found_variation(e, variation) {
    let is_print = variation.no_print !== "yes";

    let sku = document.querySelector('[data-product-sku]');

    if (sku !== null) {
        sku.textContent = variation.sku;
    }

    let price = document.querySelector('[data-product-price]');

    if (price !== null) {
        price.innerHTML = `${variation.price_html} ${wm_vars.msg_price_after}`;
    }

    let price_wrap = document.querySelector('.product-single__price');

    if (price_wrap !== null) {
        price_wrap.classList.toggle('hide', is_print);
    }

    let availability = document.querySelector('[data-product-availability]');

    if (availability !== null) {
        availability.innerHTML = variation.availability_html;
    }

    let title = document.querySelector('[data-product-title]');

    if (title !== null) {
        title.textContent = variation.name;
    }

    let modal_title = document.querySelector('[data-modal-product-title]');

    if (modal_title !== null) {
        modal_title.textContent = variation.name;
    }

    let product_field = document.querySelector('input[name="your-product"]');

    if (product_field !== null) {
        product_field.setAttribute('value', variation.name);
    }

    let modal_photo = document.querySelector('[data-modal-product-photo]');

    if (variation.image.gallery_thumbnail_src && modal_photo !== null) {
        modal_photo.innerHTML = `<img src="${variation.image.gallery_thumbnail_src}" alt="${variation.image.alt}" />`;
    }

    let print_types = document.querySelector('[data-product-print-types]');

    if (print_types !== null) {
        print_types.classList.toggle('hide', variation.no_print === 'yes');
    }

    document.querySelector('.modal-contact__product').classList.add('is-active');

    let info_container = document.querySelector('[data-product-info]');

    if (!info_container) {
        return;
    }

    let amount = variation.min_amount;
    let gramatura = variation.gramatura;

    let info = [];

    if (amount) {
        amount = wm_vars.min_amount.format(amount);
        let amount_caption = `<div class="product-single__after__item">${amount}</div>`;
        info.push(amount_caption);

        let form_amount = document.querySelector('[data-form-product-info]');

        if (form_amount) {
            form_amount.innerHTML = amount_caption;
        }
    }

    if (gramatura) {
        gramatura = wm_vars.gramatura.format(gramatura);
        info.push(`<div class="product-single__after__item">${gramatura}</div>`);
    }

    if (info) {
        info_container.innerHTML = info.join("\n");
    }
}

function wm_variation_selected(e) {
    let variation_id = e.target.value;

    if (!variation_id) {
        return;
    }

    let product = e.target.closest('.product-item');
    let variations = JSON.parse(e.target.dataset.productVariations);
    let variation = variations.find((el) => el.variation_id == variation_id);
    let is_print = variation.no_print !== "yes";

    let price = product.querySelector('[data-product-price]');

    if (price !== null) {
        if (variation.price_html) {
            price.innerHTML = variation.price_html;
        }
    }

    let price_wrap = product.querySelector('.product-item__price');

    if (price_wrap !== null) {
        price_wrap.classList.toggle('hide', is_print);
    }

    let btn = product.querySelector('.product-item__btn');

    if (btn !== null) {
        if (is_print) {
            if (variation.image.gallery_thumbnail_src) {
                btn.setAttribute('data-modal-photo', variation.image.gallery_thumbnail_src);
            }

            btn.setAttribute('data-modal-product', variation.name);
        }

        btn.classList.toggle('hide', !is_print);
    }
}

{
    let thumbs = document.querySelectorAll('.product-single__gallery a');

    if (thumbs !== null) {
        for (let el of thumbs) {
            el.addEventListener('click', wm_update_product_photo);
        }
    }

    let variation_select = document.querySelectorAll('select[data-product-variations]');

    if (variation_select !== null) {
        for (let el of variation_select) {
            el.addEventListener('change', wm_variation_selected);
        }
    }

    let cat_parents = document.querySelectorAll('.product-categories .cat-parent');

    if (cat_parents !== null) {
        for (let el of cat_parents) {
            el.addEventListener('click', (e) => { e.target.classList.toggle('is-active'); });
        }
    }
}

function wm_toggle_sizes() {
    let toggle = document.querySelector('[data-product-amount]');

    if (!toggle) {
        return;
    }

    let rawSizes = toggle.dataset.quantitySizes;

    if (!rawSizes) {
        return;
    }

    let allSizes = JSON.parse(rawSizes);

    document.addEventListener('change', function(event) {
        if (!event.target.matches('[data-product-amount]') && !event.target.matches('#pa_rozmiar')) {
            return;
        }

        let sizeSelector = document.querySelector('#pa_rozmiar');
        let options = sizeSelector.querySelectorAll('option');
        let amountInput = document.querySelector('[data-product-amount]');
        let cur = parseInt(amountInput.value) || 0;

        if (!options.length) {
            return;
        }

        let filteredSizes = allSizes.filter((item) => item.minimum >= cur);

        if (!filteredSizes.length) {
            options.forEach(el => el.disabled = false);
            return;
        }

        let allowed_sizes = filteredSizes.at(0).sizes;

        options.forEach(el => {
            let sizeValue = el.getAttribute('value');
            let shouldDisable = !allowed_sizes.includes(sizeValue) && sizeValue;
            el.disabled = shouldDisable;

            if (shouldDisable && el.selected) {
                sizeSelector.value = '';
            }
        });
    });
}

ready(() => {
    let thumb = document.querySelector('.product-single__photo [data-thumb]');
    let modal = document.querySelector('#modal-contact');

    if (thumb === null || modal === null) {
        return;
    }

    let img_url = thumb.getAttribute('data-thumb');
    let img_alt = thumb.getAttribute('data-thumb-alt');

    let modal_title = document.querySelector('[data-modal-product-title]');
    let product_name = document.querySelector('[data-product-title]').textContent;

    if (modal_title !== null) {
        modal_title.textContent = product_name;
    }

    let modal_photo = modal.querySelector('[data-modal-product-photo]');

    if (modal_photo !== null) {
        modal_photo.innerHTML = `<img src="${img_url}" alt="${img_alt}" />`;
    }

    let product_field = modal.querySelector('input[name="your-product"]');

    if (product_field !== null) {
        product_field.setAttribute('value', product_name);
    }

    modal.querySelector('.modal-contact__product').classList.add('is-active');

    wm_toggle_sizes();
});

jQuery(document).ready(function($){
    $(document).on('found_variation', wm_found_variation);
});
